import apiRequest from "@/utils/api";
import Cookies from "js-cookie";
import { TUser } from "@/types/types";

export const getAuthHeader = (): { Authorization?: string } => {
  const token = Cookies.get("jwt");
  return token ? { Authorization: `Bearer ${token}` } : {};
};

export const getUserData = (): Promise<TUser> => {
  return apiRequest("/v1/user/profile", {
    method: "GET",
    headers: getAuthHeader(),
  });
};
